import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { Router } from '@angular/router';
import { PIPImplmentsLevelVM } from '../../GET_NEW_UI/entities/global/model';
import { ProgramImprovementService } from '../../GET_NEW_UI/services/program-improvement.service';
import { PreferencesService } from '../../preferences/preferences.service';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-product-improvement-implement-dialog',
  templateUrl: './product-improvement-implement-dialog.component.html',
  styleUrls: ['./product-improvement-implement-dialog.component.scss'],
  providers: [
    DatePipe,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' }
  ],
})

export class ProductImprovementImplementDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ProductImprovementImplementDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _router:Router,  private _programImprovementService :ProgramImprovementService, 
    private readonly _pref: PreferencesService,) { }

    ImplementId: number;
    PIPImplmentsLevelList:PIPImplmentsLevelVM[]
    isLoading:boolean=false;

  ngOnInit() {
    this.ImplementId = this.data.ImplementId;
    this.GetPIPForImplement();

  }
  onCloseClick(): void {
    this.dialogRef.close();
  }

  // openProdImprovementAssetScreen(PIPId){
  
  //   this._router.navigate(['/product-improvement-asset', this.ImplementId, PIPId ]);

  
  // }

  
  openProdImprovementAssetScreen(Id,PIPId) {
    if (PIPId) {
     // console.log("pipId",PIPId)
      //this._router.navigate(['/editdigitalformscomponent', form.Id]);
     

     // window.open('/product-improvement-asset/' + this.ImplementId + '/' + Id + '/' + PIPId, '_blank');
     this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
      if(res=="True"){
        this._router.navigate(['/product-improvement-asset', this.ImplementId, Id, PIPId]);
        this.dialogRef.close();
      }else{             
        window.open('/product-improvement-asset/' + this.ImplementId + '/' + Id + '/' + PIPId, '_blank');
        this.dialogRef.close();
       
      }
  });

    } else {
      //this._router.navigate(['/uploadformedit', form.Id]);
      window.open('/product-improvement-asset/');
  
    }
  }

  GetPIPForImplement(){
    this.isLoading=true;
    this._programImprovementService.GetAllForImplement(this.ImplementId).subscribe(res=>{
      this.PIPImplmentsLevelList=res
      this.isLoading=false;
    })
  }
}
